// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"95":"28db70e9","168":"6da51707","289":"c54f3268","461":"35dc1859","613":"f1c4bbe9","696":"1f985062","728":"a3a70494","911":"df8f449c","936":"ff92a6f2"}[chunkId] + ".js";
};